import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import FlightSaleChannel from '../entities/flight/flightSaleChannel';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface FlightSaleChannelState extends ListState<FlightSaleChannel> {
  flightSaleChannel: FlightSaleChannel;
  editFlightSaleChannel: FlightSaleChannel;
}

class FlightSaleChannelMutations extends ListMutations<FlightSaleChannel> {}

class FlightSaleChannelModule extends ListModule<
  FlightSaleChannelState,
  any,
  FlightSaleChannel
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<FlightSaleChannel>(),
    loading: false,
    editFlightSaleChannel: new FlightSaleChannel(),
    selectFlightSaleChannel: new FlightSaleChannel(),
  };
  actions = {
    async selectFlightSaleChannel(
      context: ActionContext<FlightSaleChannelState, any>,
      payload: any
    ) {
      context.state.editFlightSaleChannel = payload.data;
    },

    async saveFlightSaleChannel(
      context: ActionContext<FlightSaleChannelState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveFlightSaleChannel',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightSaleChannel>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateFlightSaleChannel(
      context: ActionContext<FlightSaleChannelState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Flight/UpdateFlightSaleChannel',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightSaleChannel>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getFlightSaleChannels(
      context: ActionContext<FlightSaleChannelState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetFlightSaleChannels',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<FlightSaleChannel>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteFlightSaleChannel(
      context: ActionContext<FlightSaleChannelState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteFlightSaleChannel?input=' +
          payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: FlightSaleChannelState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: FlightSaleChannelState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const flightSaleChannelModule = new FlightSaleChannelModule();
export default flightSaleChannelModule;
